import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionTypesComponent } from 'src/app/pages/subscription-settings/subscription-types/subscription-types.component';
import { BadgeDetailsComponent } from './badge-details/badge-details.component';
import { BadgeComponent } from './badge/badge.component';
import { PaymentResponseMessageDetailComponent } from './payment-response-message-detail/payment-response-message-detail.component';
import { PaymentResponseMessageTypeDetailComponent } from './payment-response-message-type-detail/payment-response-message-type-detail.component';
import { PaymentResponseMessageTypeComponent } from './payment-response-message-type/payment-response-message-type.component';
import { PaymentResponseMessageComponent } from './payment-response-message/payment-response-message.component';
import { CardUpdaterComponent } from './card-updater/card-updater.component';
import { CardVerificationComponent } from './card-verification/card-verification.component';
import { CheckoutGatewayPriorityComponent } from './checkout-gateway-priority/checkout-gateway-priority.component';
import { CheckoutJourneyCollectorComponent } from './checkout-journey-collector/checkout-journey-collector.component';
import { MercadoPagoRetentionThreeDsComponent } from './mercadopago-retention-3ds/mercadopago-retention-3ds.component';
import { PixComponent } from './pix/pix.component';
import { SubscriptionTypeDetailsComponent } from './subscription-types/subscription-type-details/subscription-type-details.component';

const routes: Routes = [
  {
    path: 'badge',
    component: BadgeComponent
  },
  {
    path: 'badge/:badgeId',
    component: BadgeDetailsComponent
  },
  {
    path: 'subscription-types',
    component: SubscriptionTypesComponent
  },
  {
    path: 'subscription-types/:subscriptionTypeId',
    component: SubscriptionTypeDetailsComponent
  },
  {
    path: 'pix',
    component: PixComponent
  },
  {
    path: 'card-verification',
    component: CardVerificationComponent
  },
  {
    path: 'card-updater',
    component: CardUpdaterComponent
  },
  {
    path: 'mercadopago-retention-3ds',
    component: MercadoPagoRetentionThreeDsComponent
  },
  {
    path: 'checkout-journey-collector',
    component: CheckoutJourneyCollectorComponent
  },
  {
    path: 'checkout-gateway-priority',
    component: CheckoutGatewayPriorityComponent
  },
  {
    path: 'payment-response-message-type',
    component: PaymentResponseMessageTypeComponent
  },
  {
    path: 'payment-response-message-type/:paymentResponseMessageTypeId',
    component: PaymentResponseMessageTypeDetailComponent
  },
  {
    path: 'payment-response-message',
    component: PaymentResponseMessageComponent
  },
  {
    path: 'payment-response-message/:paymentResponseMessageId',
    component: PaymentResponseMessageDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionSettingsRoutingModule {}
